import React from 'react'

const Graphics = () => {
  return (
    <div className="graphics-page-container">
      <h1>designer.</h1>
    </div>
  )
}
export default Graphics